import {
  ArrowLeftOutlined,
  CheckOutlined,
  DeleteOutlined,
  LoadingOutlined
} from '@ant-design/icons';
import {
  CustomInput,
  CustomMobileInput,
  CustomAddressSelect
} from 'components/formik';
import { ACCOUNT } from 'constants/routes';
import { useModal } from 'hooks';
import { Field, useFormikContext } from 'formik';
import PropType from 'prop-types';
import React from 'react';
import { useDispatch } from 'react-redux';
import { deleteUser } from 'redux/actions/authActions';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import DeleteModal from './DeleteModal';

const EditForm = ({ isLoading, authProvider }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { values, submitForm } = useFormikContext();
  const modal = useModal();
  const dispatch = useDispatch();

  const onConfirmDelete = () => {
    modal.onOpenModal();
  };

  const deleteAccount = (password) => {
    dispatch(
      deleteUser({
        password
      })
    );
    modal.onCloseModal();
  };

  const onDeleteUpdate = (password) => {
    if (password) {
      deleteAccount(password);
    }
  };

  return (
    <div className="user-profile-details">
      <Field
        disabled={isLoading}
        name="fullname"
        type="text"
        label={`* ${t('signUpNameLabel')}`}
        component={CustomInput}
        style={{ textTransform: 'capitalize' }}
      />
      <Field
        disabled={authProvider !== 'password' || isLoading}
        name="email"
        type="email"
        label="* Email"
        component={CustomInput}
      />
      <CustomAddressSelect
        name="address"
        defaultMunicipality={values.address.municipality}
        defaultProvince={values.address.province}
        defaultRegion={values.address.region}
        defaultCountry={values.address.country}
        defaultNpa={values.address.npa}
      />
      <CustomMobileInput
        defaultValue={values.mobile}
        name="mobile"
        disabled={isLoading}
        label={t('userFieldPhone')}
      />
      <br />
      <div className="edit-user-action">
        <button
          className="button w-100-mobile"
          disabled={isLoading}
          onClick={submitForm}
          type="button"
        >
          {isLoading ? <LoadingOutlined /> : <CheckOutlined />}
          &nbsp;
          {isLoading ? t('loadingMessage') : t('buttonUpdate')}
        </button>
        <button
          className="button button-danger w-100-mobile"
          onClick={onConfirmDelete}
          type="button"
        >
          <DeleteOutlined />
          &nbsp; {t('buttonDelete')}
        </button>
      </div>
      <div>
        <button
          className="button button-muted w-100-mobile"
          disabled={isLoading}
          onClick={() => history.push(ACCOUNT)}
          type="button"
        >
          <ArrowLeftOutlined />
          &nbsp; {t('backProfileButton')}
        </button>
        <DeleteModal onDeleteUpdate={onDeleteUpdate} modal={modal} />
      </div>
    </div>
  );
};

EditForm.propTypes = {
  isLoading: PropType.bool.isRequired,
  authProvider: PropType.string.isRequired
};

export default EditForm;
